<template>
	<ul v-if="loading" class="list">
		<li :key="i" v-for="(item, i) in items" class="item">
			<el-skeleton style="width: 100%" :loading="loading" animated>
				<template slot="template">
					<el-container>
						<div style="display: inline-flex; align-items: center">
							<el-skeleton-item style="width: 33px; height: 33px; margin-right: 5px" />
							<el-skeleton-item style="width: 33px; height: 33px; margin-right: 5px" />
							<el-skeleton-item style="width: 33px; height: 33px; margin-right: 5px" />
						</div>
						<el-main style="padding: 0px; margin-left: 20px; width: 50%; margin-top: 5px">
							<el-skeleton-item variant="h3" style="width: 40%" />
							<el-skeleton-item variant="text" style="width: 70%" />
						</el-main>
						<div style="display: inline-flex; align-items: center; width: 50%">
							<el-skeleton-item variant="text" style="width: 100%" />
							<el-divider direction="vertical"></el-divider>
							<el-skeleton-item variant="text" style="width: 100%" />
							<el-divider direction="vertical"></el-divider>
							<el-skeleton-item variant="text" style="width: 100%" />
							<el-divider direction="vertical"></el-divider>
							<el-skeleton-item variant="text" style="width: 100%" />
						</div>
					</el-container>
				</template>
			</el-skeleton>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		items: Number,
	},
};
</script>

<style scoped>
.list {
	margin: 0;
	list-style-type: none;
	padding: 2px;
}

.item {
	background-color: white;
	height: 70px;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 20px;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 20px;
}
</style>
